import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoService } from '@jsverse/transloco';
import { APP_CONFIG, AppConfig } from '@pulpo/app-config';
import {
  PrestationLock,
  newBackOfficePageUrl,
  tripPreviewUrl,
} from '@pulpo/pulpo-models';

/**
 * Tells why a legacy prestation (option, insurance, hotel, formality) is read-only: one of the
 * products using it was imported into a trip, which now holds its copy. Links to that copy in the
 * new back-office, and to the trip.
 */
@Component({
  selector: 'pulpo-prestation-lock-banner',
  templateUrl: './prestation-lock-banner.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatCardModule, MatIconModule],
})
export class PrestationLockBannerComponent {
  @Input({ required: true }) lock!: PrestationLock;
  /** Where the prestation lives in the new back-office, e.g. `options/{id}/details`. */
  @Input() prestationPath: string | null = null;

  private readonly config = inject<AppConfig>(APP_CONFIG);
  private readonly transloco = inject(TranslocoService);

  get prestationUrl(): string | null {
    return newBackOfficePageUrl(
      this.config.newBackOfficeUrl,
      this.transloco.getActiveLang(),
      this.prestationPath
    );
  }

  get tripUrl(): string | null {
    return tripPreviewUrl(
      this.config.newBackOfficeUrl,
      this.transloco.getActiveLang(),
      this.lock.tripId
    );
  }
}
